<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" class="button" @click="$router.go(-1)">返回</button>&nbsp;&nbsp;
				<span class="red">当前地址:{{customer.currentAddress}} (如果未设置收货地址则以会员柜式店铺地址作为默认地址)</span>
			</p>
			<p>
				<hr style="margin: .5rem;" />
				<span v-if="customer.CustomerID>0"
					class="red">{{customer.CustomerName}}&nbsp;{{customer.CustomerPhone}}&nbsp;{{customer.ShopName}}&nbsp;{{ $moment (customer.VipBeginDate).format('YYYY年MM月DD日') +'~'+ $moment (customer.VipEndDate).format('YYYY年MM月DD日')}}
					{{customer.boxMoney>=60?'有书箱':'无书箱'}}
				</span>
				<button type="button" class="button" :disabled="customer.boxMoney<60"
					:class="{'disabled':customer.boxMoney<60,'add':customer.boxMoney>=60}"
					@click="addAddress">+新增地址</button>
			</p>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>手机号</th>
						<th>详细地址</th>
						<th>默认地址</th>
						<th>修改</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in customer.shopaddress">
						<td>
							{{index+1}}
						</td>
						<td>
							{{i.Phone}}
						</td>
						<td>
							{{i.ReceivingAddress}}
						</td>
						<td>
							<button v-if="customer.addressID!=i.AddressID" type="button" @click="setDeault(i)"
								class="button" >
								设为默认
							</button>
							<span v-if="customer.addressID==i.AddressID" class="red">默认地址</span>
						</td>
						<td>
							<button @click="updateAddress(i)" type="button" class="button">
								修改
							</button>
						</td>
					</tr>
					<tr v-for="(i,index) in customer.address">
						<td>
							{{index+1}}
						</td>
						<td>
							{{i.Phone}}
						</td>
						<td>
							{{i.ReceivingAddress}}
						</td>
						<td>
							<button v-if="customer.addressID!=i.AddressID" type="button" @click="setDeault(i)"
								class="button" >
								设为默认
							</button>
							<span v-if="customer.addressID==i.AddressID" class="red">默认地址</span>
						</td>
						<td>
							<button @click="updateAddress(i)" type="button" class="button">
								修改
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="edit" v-show="Edit!=''">
			<div>
				<p>
					<label>
						<span class="red"></span>手&nbsp;&nbsp;机&nbsp;&nbsp;号:
						<input type="text" v-model="customerPhone" placeholder="请输入借书手机号" />
					</label>
				</p>
				<p>
					<label>
						详细地址:
						<textarea v-model="ReceivingAddress" placeholder="请输入详细地址(10字以上)">

						 </textarea>
					</label>
				</p>
				<p>
					<button class="button" :class="{'disabled':!checkAddress}" :disabled="!checkAddress"
						@click="editAddress">{{addressID>0?'修改':'添加'}}</button>
					<button class="button" @click="Edit=''">取消</button>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import j from './index.js'
	export default j
</script>

<style>
</style>
